import { useLocation } from "react-router";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non existent route:", location.pathname);
    const prevTitle = document.title;
    const prevDesc = document.querySelector('meta[name="description"]')?.getAttribute("content") ?? "";
    const prevOgTitle = document.querySelector('meta[property="og:title"]')?.getAttribute("content") ?? "";
    const prevOgDesc = document.querySelector('meta[property="og:description"]')?.getAttribute("content") ?? "";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex";
    document.head.appendChild(robots);
    document.title = "Page Not Found (404) | OZ MOVE CO.";
    document.querySelector('meta[name="description"]')?.setAttribute("content", "The page you're looking for doesn't exist. Return to OZ MOVE CO. for fast, reliable Australian moving services.");
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", "Page Not Found (404) | OZ MOVE CO.");
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", "The page you're looking for doesn't exist.");
    return () => {
      document.title = prevTitle;
      document.querySelector('meta[name="description"]')?.setAttribute("content", prevDesc);
      document.querySelector('meta[property="og:title"]')?.setAttribute("content", prevOgTitle);
      document.querySelector('meta[property="og:description"]')?.setAttribute("content", prevOgDesc);
      robots.remove();
    };
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
